var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main" },
    [
      _c("page-title"),
      _vm._v(" "),
      _c("page-card", { staticClass: "no-padding", attrs: { noHead: true } }, [
        _c(
          "div",
          { staticClass: "page-table", attrs: { slot: "body" }, slot: "body" },
          [
            _vm.activeName == 1 ? _c("mineral") : _vm._e(),
            _vm._v(" "),
            _vm.activeName == 2 ? _c("digital") : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }